import { useQuery } from '@apollo/client'

import { GetTenantConfigDocument } from '@app/graphql'

/**
 * Returns whether subscriptions (subscribe card, subscription menu items, VIP-only toggle)
 * are available for the current tenant, driven by the `subscriptions` flag in the
 * `feature_flags` table. Enabled by default — a tenant opts out with a row where enabled = false.
 * Hidden while the tenant config is loading so opted-out tenants never see a flash of it.
 */
export function useSubscriptionsEnabled(): boolean {
  const { data, loading } = useQuery(GetTenantConfigDocument, { fetchPolicy: 'cache-first' })

  if (loading && !data) return false

  const flag = data?.tenantConfig?.featureFlags?.find(f => f.key === 'subscriptions')

  return flag?.enabled ?? true
}
